// Keep both label categories visible, including empty categories on old drafts.
export const qualityLabelPhotos = (photos = []) => [
  ['MESH_LABEL', 'Etiqueta de la malla'], ['BOX_LABEL', 'Etiqueta de la caja'],
].flatMap(([type, label]) => {
  const matches = photos.filter(photo => photo.photoType === type)
  return matches.length ? matches.map((photo, index) => ({
    label: matches.length > 1 ? `${label} ${index + 1}` : label,
    url: photo.previewUrl,
  })) : [{ label, url: '' }]
})
